import { pdfjs, Document, Page } from "react-pdf";
import React, { useEffect, useRef, useState } from "react";
import { getSignedUrl, updateDocumentProgress } from "ServerAPI/serverAPI";
import { Spinner, Container, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { ROLES } from "constants/Constants";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfViewer = ({ fileName, activeContent }) => {
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cookies, setCookies] = useCookies();
  const { courseId, sectionId } = useParams();

  const totalPagesRef = useRef(numPages);
  const currentPageRef = useRef(pageNumber);

  useEffect(() => {
    totalPagesRef.current = numPages;
  }, [numPages]);

  useEffect(() => {
    currentPageRef.current = pageNumber;
  }, [pageNumber]);

  const updateProgress = async () => {
    const body = {
      courseId: courseId,
      sectionId: sectionId,
      contentId: activeContent?.contentId,
      completedStatus: totalPagesRef.current === currentPageRef.current,
      documentProgress: currentPageRef.current,
      userId: cookies.userId,
    };

    if (activeContent.completedStatus !== true) {
      await updateDocumentProgress(body);
    }
    console.log("updateProgress", body);
    return;
  };

  useEffect(() => {
    setPageNumber(activeContent.documentProgress || 1);

    return () => {
      if (cookies.roleId === ROLES.COURSE_PARTICIPANT) {
        updateProgress();
      }
    };
  }, []);

  useEffect(() => {
    const unloadCallback = async () => {
      if (document.visibilityState === "hidden") {
        updateProgress();
      }
      return;
    };

    if (cookies.roleId === ROLES.COURSE_PARTICIPANT) {
      window.addEventListener("visibilitychange", unloadCallback);
    }

    return () => window.removeEventListener("visibilitychange", unloadCallback);
  }, []);

  useEffect(() => {
    const getPdf = async () => {
      setLoading(true);
      const payload = {
        courseId: courseId,
        sectionId: sectionId,
        fileName: fileName,
        method: "GET",
        userId: cookies?.userId,
      };
      try {
        const response = await getSignedUrl(payload);
        const generatedUrl = response.data.preSignedUrl;
        setPdfUrl(generatedUrl);
      } catch (error) {
        console.error("Error fetching PDF URL:", error);
      } finally {
        setLoading(false);
      }
    };
    getPdf();
  }, [fileName, courseId, sectionId]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const goToPreviousPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    if (value === "" || !isNaN(value)) {
      setPageNumber(value === "" ? "" : Number(value));
    }
  };

  return (
    <section className="mt-4 course-container ">
      <Container fluid>
        <div className="content ">
          {/* <div className="d-flex justify-content-center align-items-center min-vh-70 bg-white py-4"> */}
          <div className="border border-primary rounded-3 shadow-sm w-100   p-0">
            {/* Header Section */}
            <div className="d-flex justify-content-between align-items-center p-2 bg-light border-bottom border-primary rounded-top">
              <span className="fs-5 fw-bold text-primary">{fileName}</span>
            </div>

            {/* PDF Rendering Section */}
            {/* <div className="w-100 h-50 overflow-auto d-flex justify-content-center"> */}
            {loading ? (
              <div className="d-flex justify-content-center align-items-center w-100 h-100">
                <Spinner animation="border" />
              </div>
            ) : pdfUrl ? (
              <div className="d-flex flex-column justify-content-center overflow-auto align-items-center w-100   bg-light border">
                <div
                  style={{ height: "74vh" }}
                  className="border overflow-auto"
                >
                  <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
                    <Page
                      className=" d-block mx-auto"
                      pageNumber={pageNumber}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  </Document>
                </div>

                {/* Navigation Controls */}
                <div className="d-flex justify-content-center gap-2 mt-2 p-2">
                  <button
                    className="btn btn-primary"
                    onClick={goToPreviousPage}
                    disabled={pageNumber <= 1}
                  >
                    Prev
                  </button>

                  <input
                    type="number"
                    min="1"
                    max={numPages}
                    value={pageNumber}
                    onChange={handleChange}
                    className="form-control w-auto text-center"
                  />
                  <span className="pt-2">of {numPages}</span>

                  <button
                    className="btn btn-primary"
                    onClick={goToNextPage}
                    disabled={pageNumber >= numPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            ) : (
              <div>No PDF available</div>
            )}
            {/* </div> */}
          </div>
          {/* </div> */}
        </div>
      </Container>
    </section>
  );
};

export default PdfViewer;
